<template>
  <v-base-toolbar title="Reglas para atributos" @toggle-sidebar="toggleSidebar">
    <v-slide-x-transition>
      <v-toolbar-title v-if="itemsTotal">{{itemsTotal}} Matching Items</v-toolbar-title>
    </v-slide-x-transition>
  </v-base-toolbar>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import VBaseToolbar from "@/components/toolbars/BaseToolbar.vue";

export default {
  components: {
    VBaseToolbar
  },
  computed: {
    ...mapState("featureRules", ["itemsTotal", "showSidebar"])
  },
  methods: {
    ...mapMutations("featureRules", ["setShowSidebar"]),
    toggleSidebar() {
      this.setShowSidebar(!this.showSidebar);
    }
  }
};
</script>
